import React from 'react';
import classnames from 'classnames';

import Avatar from './Avatar';
import NotEnoughFateWarning from './NotEnoughFateWarning';

export default function PurchaseFaceComponent(props) {
  const {
    activePurchase,
    avatars,
    currentFate,
    fateCost,
    isFree,
    onRequestClose,
  } = props;
  const canAffordFaceChange = currentFate >= fateCost;
  return (
    <div>
      <h3 className="heading heading--2 heading--inverse">Change your face</h3>
      <NotEnoughFateWarning {...props} />
      {isFree && <FreeFaceChangeRubric />}
      <hr />
      <div>
        <ul
          className="list--unstyled avatar-list"
          style={{
            maxHeight: '60vh',
            overflowY: 'scroll',
          }}
        >
          {avatars.map(avatar => (
            <li
              key={avatar}
              className={classnames(
                'avatar-list__item',
                !(isFree || canAffordFaceChange) && 'avatar-list__item--disabled',
              )}
            >
              <Avatar
                activePurchase={activePurchase}
                avatar={avatar}
                disabled={!(isFree || canAffordFaceChange)}
                isFree={isFree}
                fateCost={fateCost}
                onRequestClose={onRequestClose}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function FreeFaceChangeRubric() {
  return (
    <div>
      You have an opportunity to change your face. Choose your new face below.
    </div>
  );
}